import { GenerateDataType, MapCategory } from "interfaces/models/generateData";
import ForgeDataImporter from ".";

class CategoryInfoImporter extends ForgeDataImporter<MapCategory> {
  dataType = GenerateDataType.CATEGORY_INFO;

  normalizeData(_data: any[]): Promise<MapCategory> {
    let result: MapCategory = {};
    _data.forEach((item) => {
      if (Object.keys(item).length) {
        result = Object.assign(result, item);
      }
    });

    return Promise.resolve(result);
  }
}

export default CategoryInfoImporter;
